// extracted by mini-css-extract-plugin
export default {"button":"ConfirmationPopup_button__9th3Z"};